import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export function trackBattlesClick(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.ARENA_CLICK, data);
}

export function trackBattlesAdImpression(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.ARENA_AD_IMPRESSION, data);
}
